module.exports = __webpack_public_path__ + "44944d1a.svg";